import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";

export class AttributePresenceHtmlBridgePrototype extends HtmlBridgePrototype{
    public attributeName:string;
    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new AttributePresenceBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

class AttributePresenceBridge extends HtmlBridge{
    
    private attributeName:string;
    private binding:IBinding;
    private element:HTMLElement;
    private bindingPrototype : BindingPrototype;
    
    constructor(prototype:AttributePresenceHtmlBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
        this.attributeName = prototype.attributeName;
    }
    
    public set value(v: boolean) {
        this._value = v; 
        if(this.value)
            this.element.setAttribute(this.attributeName,'');
        else
            this.element.removeAttribute(this.attributeName);    
    } public get value(): boolean { return this._value;} private _value: boolean;
    
    
    public create(view: View<ViewModel>, node: Node){
        this.element = node as HTMLElement;
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'value'));
    }
    
    release() {
        this.binding.release();
    }

}